import React from 'react'
import { Navigate, Outlet, useLoaderData } from 'react-router-dom'
import PropTypes from 'prop-types'
import { getToken } from 'shared/util/storage'

const PrivateRoute = () => {
  const decode = useLoaderData()
  if (!getToken()) return <Navigate to="/login" replace />
  return <Outlet context={{ decode }} />
}

PrivateRoute.propTypes = {
  children: PropTypes.node
}

export default PrivateRoute
